/**
 * Label Request model for create/update API calls
 */
export class LabelRequest {
  /**
   * @param {Object} params
   * @param {string} params.nameTh - Thai name (required)
   * @param {string} params.nameEn - English name
   * @param {string} params.nameZh - Chinese name
   * @param {string[]} params.packageIds - Array of package IDs
   */
  constructor({ nameTh, nameEn = '', nameZh = '', packageIds = [] }) {
    this.name = {
      th: nameTh?.trim() || '',
      en: nameEn?.trim() || '',
      zh: nameZh?.trim() || ''
    };
    this.packageIds = packageIds;
  }

  /**
   * Create from form data and selected packages
   * @param {Object} form - Form data with nameTh, nameEn, nameZh
   * @param {Array} selectedPackages - Array of package objects with id
   * @returns {LabelRequest}
   */
  static fromForm(form, selectedPackages = []) {
    return new LabelRequest({
      nameTh: form.nameTh,
      nameEn: form.nameEn,
      nameZh: form.nameZh,
      packageIds: selectedPackages.map(pkg => Number(pkg.id))
    });
  }

  /**
   * Convert to plain object for API request
   * @returns {Object}
   */
  toJSON() {
    return {
      name: this.name,
      packageIds: this.packageIds
    };
  }
}
